import React, { useEffect } from "react";
import { useAppContext } from "../../context/AppContext";
import { useNavigate } from "react-router-dom";
//primereact
import { Button } from "primereact/button";

import lightLogo from "../../assets/logo.png";
// import gifTeste from "../../assets/cartão.mp4";

import darkLogo from "../../assets/darkLogo.png";
import errorimage from "../../assets/errors/gif403.gif";
const Error401 = () => {
  const context = useAppContext();
  const navigate = useNavigate();
  const dark = localStorage.getItem('appDarkMode')
// site
  useEffect(() => {
    context.handleSetAppSidebarNone(true);
    context.handleSetAppHeaderNone(true);
    context.handleSetAppContentClass("p-0");

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppHeaderNone(false);
      context.handleSetAppContentClass("");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div
        className="d-flex justify-content-center "
        style={{ height: "100vh", overflow: "hidden", backgroundColor: dark === 'false' ? "#FFFFFF" : "#161A1D" }}
      >
        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center position-relative">
        <img src={dark === 'false' ? darkLogo : lightLogo} width={250} alt="logo" className="position-absolute" style={{top: '30px'}}/>
          <img src={errorimage} alt="error" width="70%" style={{filter: 'hue-rotate(45deg)'}}/>
          {/* <video src={gifTeste} alt="error" width="70%" loop autoPlay muted/> */}
          <h2 className="text-center">
            Sem permissão para acessar essa sessão
          </h2>
          <div className="d-flex">
          <Button
            rounded
            icon="fa-solid fa-chevron-left"
            label="Voltar"
            className="bg-blue mt-3"
            onClick={() => navigate(-2)}
          />
          <h2 className="my-auto mx-4">Ou</h2>
          <Button
            rounded
            icon="fa-solid fa-chevron-right"
            iconPos="right"
            label="Ir para login"
            className="bg-blue mt-3"
            onClick={() => navigate("/")}
          />
          </div>
        </div>
      </div>
    </>
  );
};

export default Error401;
